import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "MisuseAlt"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.0575 17.25L12 13.1932L7.9425 17.25L6.75 16.0575L10.8067 12L6.75 7.94325L7.94325 6.75L12 10.8067L16.0568 6.75L17.25 7.94325L13.1932 12L17.25 16.0575L16.0575 17.25ZM1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C14.7848 1.5 17.4555 2.60625 19.4246 4.57538C21.3938 6.54451 22.5 9.21523 22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12ZM21 12C21 7.02944 16.9706 3 12 3C7.03184 3.00579 3.00579 7.03184 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/MisuseAlt.vue"]]);
